import React from 'react';

const PC: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  return React.cloneElement(children, {
    ...children.props,
    className: `${children.props.className || ''} show-pc hide-mobile`,
  });
};

export default PC;
